import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Core2Config } from '../shared/core2Config';
import { InventoryOpdgElementContainerModel, InventoryOpdgElementReportContainerModel } from '../../../../../models/aggregates/inventory-opdg-element';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { ApiVisa } from '../shared/api-visa.model';
import { PagingResponseModel } from '../shared/api-response.model';
import { InventoryOpdgElementReportQueryCriteriaClass, InventoryOpdgElementReportQueryCriteriaModelQuery } from '../../criteria/inventory-opdg-element-report-query-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class InventoryOpdgElementService extends BaseApiPublicLoginTemplateService<InventoryOpdgElementContainerModel,InventoryOpdgElementContainerModel,InventoryOpdgElementContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'opdg-elements/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'opdg-elements/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }

  getOpdgReport(criteria: InventoryOpdgElementReportQueryCriteriaClass, visa: ApiVisa): Observable<PagingResponseModel<InventoryOpdgElementReportContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const buildCriteria = new InventoryOpdgElementReportQueryCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<InventoryOpdgElementReportContainerModel>>(
      this.apiUrl + '/opdg-report?' + buildCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}